const borderRadii = {
  small: '8px',
  medium: '24px',
} as const;

export default borderRadii;

export type ThemeBorderRadii = typeof borderRadii;
export type ThemeBorderRadiiKeys = keyof typeof borderRadii;
